module.exports = __webpack_public_path__ + "static/media/icon-supplier-discovery.53e064ef.svg";